import { Modal } from 'antd';
import styled from 'styled-components';

export const StyledModal = styled(Modal)`
  .ant-modal-content {
    border-radius: 0 !important;
    border: 1px solid ${({ theme }) => theme.colors.grey_3} !important;
    padding: 0 !important;
  }

  .ant-modal-header {
    border-radius: 0 !important;
    border-bottom: 1px solid ${({ theme }) => theme.colors.grey_3} !important;
  }

  .ant-modal-body {
    padding: 0 !important;
  }

  .ant-modal-close {
    top: 16px !important;
    right: 16px !important;
  }

  .ant-modal-close-x {
    color: ${({ theme }) => theme.colors.grey_2} !important;
    font-size: 18px !important;

    &:hover {
      color: ${({ theme }) => theme.colors.grey_1} !important;
    }
  }
`;

export const LockedFeatureModalContainer = styled.div`
  width: 100%;
  border-width: 1px;
  box-sizing: border-box;
  display: flex;
  justify-content: center;
`;
